<template>
    <div>
        <section class="section-title-page  container-fluid"
            style="background-image: url('/img/bg_tramite.jpg');">
            <div class="container">
                <div class="wrapper">
                    <h1>Servicios <small style="font-weight: 300;">a tu disposición</small></h1>
                    <span>
                        Volver <i class="fa fa-angle-right mx-1"></i>
                        <a href="/">Inicio</a>
                    </span>
                </div>
            </div>
        </section>

        <section class="section-page container-fluid">
			<div class="container">
				<div class="section-info">
					<p class="m-0"><i class="fa-solid fa-circle mr-2"></i>Accede a nuestros servicios diseñados para facilitar trámites, búsquedas o consultas. Para comenzar, <strong>haz clic</strong> en el servicio deseado.</p>
				</div>
			</div>
			<div class="services mt-4 container">
				<div class="wrapper">
					<a href="/mesa_partes_virtual" class="stack">
						<div class="icon">
							<i class="fa-solid fa-book-open"></i>
						</div>
						<div class="text">
							<h5>Mesa de partes Virtual</h5>
							<p>Permite a los colegiados y ciudadanos en general realizar trámites administrativos de manera completamente en línea.</p>
						</div>
					</a>
					<a href="/busqueda_colegiado" class="stack">
						<div class="icon">
							<i class="fa-solid fa-magnifying-glass"></i>
						</div>
						<div class="text">
							<h5>Búsqueda colegiados </h5>
							<p>Este servicio permite a los usuarios consultar el registro oficial de los médicos veterinarios colegiados en nuestra institución.</p>
						</div>
					</a>
					<!--
					<a href="search-certificates.html" class="stack">
						<div class="icon">
							<i class="fa-solid fa-magnifying-glass"></i>
						</div>
						<div class="text">
							<h5 >Certificados del CMVDSM</h5>
							<p>Este servicio permite verificar la validez de los certificados emitidos por el Colegio, como los de Salud de Menores, Salus de Mayores, Eutanacia, etc.</p>
						</div>
					</a>
					-->
					<a href="/estadisticas_colegiados" class="stack">
						<div class="icon">
							<i class="fa-solid fa-chart-simple"></i>
						</div>
						<div class="text">
							<h5>Estadística Colegiados</h5>
							<p>Es una herramienta útil para entender mejor las tendencias en el registro profesional sobre la composición de género en los diferentes años.</p>
						</div>
					</a>
					<!--
					<a href="book-reclamations.html" class="stack">
						<div class="icon">
							<i class="fa-solid fa-book"></i>
						</div>
						<div class="text">
							<h5>Libro Reclamaciones Virtual</h5>
							<p>El Libro de Reclamaciones Virtual es un espacio donde los usuarios pueden registrar sus reclamos o sugerencias relacionadas con los servicios brindados por el Colegio.</p>
						</div>
					</a>-->
					<a href="/bolsa_trabajo" class="stack">
						<div class="icon">
							<i class="fa-solid fa-bag-shopping"></i>
						</div>
						<div class="text">
							<h5>Bolsa de Trabajo</h5>
							<p>La Bolsa de Trabajo ofrece a los colegiados la oportunidad de acceder a convocatorias laborales en su campo profesional.</p>
						</div>
					</a>
					<!--
					<a href="formalization.html" class="stack">
						<div class="icon">
							<i class="fa-solid fa-graduation-cap"></i>
						</div>
						<div class="text">
							<h5>Formalización Colegiado </h5>
							<p>La Formalización de Colegiados está orientada a facilitar los trámites necesarios para que los profesionales veterinarios se regularicen en el colegio.</p>
						</div>
					</a>-->
				</div>
			</div>
		</section>  
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'servicios',
    computed: {
        ...mapState(['empresa']),
    },
    created() {
    },
    mounted() {
		this.setLoading(true)
    },
    data() {
        return {

        }
    },
    methods: {
        ...mapMutations(['setLoading']),
		
    },
}
</script>